<template>
  <Container>
    <div class="wizard">
      <v-layout align-center justify-center row fill-height>
        <v-flex md6 sm8>
          <div class="wizard__welcome">
            <h1 class="wizard__welcome__title">{{ $t(`${namespace}.title`) }} <span>{{ $t(`${namespace}.99`) }}!</span></h1>
            <p class="wizard__welcome__subtitle" v-html="$t(`${namespace}.subtitle`)" />
            <p class="wizard__welcome__text" v-html="$t(`${namespace}.text`)" />

            <v-btn
              color="warning--gradient"
              class="mx-0"
              round
              depressed
              large
              @click="handleSetStep"
            >
              {{ $t(`${namespace}.start`) }}
            </v-btn>

            <div class="wizard__escape__container">
              <a
                :title="$t(`${namespace}.skipTutorial`)"
                class="wizard__escape"
                @click="openAccessPlatformDialog"
              >
                {{ $t(`${namespace}.skipTutorial`) }}
              </a>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div class="wizard__line" />
    </div>
  </Container>
</template>

<script>
import Container from 'components/wizard/Container'

export default {
  name: 'Welcome',
  components: {
    Container
  },
  data () {
    return {
      namespace: 'Views.Wizard.welcome'
    }
  },
  methods: {
    handleSetStep () {
      this.$ga.event('botao', 'clicou', 'comecar_tutorial')
      this.$emit('handleSetStep', {
        step: 'form'
      })
    },

    openAccessPlatformDialog () {
      this.$ga.event('botao', 'clicou', 'pular_tutorial')
      this.$emit('openAccessPlatformDialog')
    }
  },
  mounted () {
    this.$ga.event('navegacao', 'exibiu', 'wizard')
  }
}
</script>

<style lang="scss" scoped>
.wizard {
  overflow: hidden;
  position: relative;

  @media (min-width: 848px) {
    &:before,
    &:after {
      background-position: center;
      background-repeat: no-repeat;
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &:before {
      background-image: url('./img/man.svg');
      height: 283px;
      left: -25px;
      margin-top: -30px;
      width: 255px;
    }

    &:after {
      background-image: url('./img/woman.svg');
      height: 245px;
      margin-top: -20px;
      right: 0;
      width: 233px;
    }
  }
}

.wizard__welcome {
  color: $gray-8;
  padding: 0 15px;
  text-align: center;

  @media (min-width: 992px) {
    padding: 0 30px;
  }
}

.wizard__welcome__title,
.wizard__welcome__subtitle {
  font-family: 'Montserrat', sans-serif;
}

.wizard__welcome__title {
  font-size: 24px;
  font-weight: 800;
  line-height: normal;
  margin-bottom: 10px;

  @media (min-width: 992px) {
    font-size: 36px;
  }

  span {
    color: $accent;
  }
}

.wizard__welcome__subtitle {
  color: $gray-6;
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 40px;

  strong {
    color: $gray-8 !important;
    font-weight: 700;
  }
}

.wizard__welcome__text {
  color: $gray-6;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 30px;
  padding: 0 40px;

  @media (min-width: 992px) {
    margin-bottom: 140px;
  }

  strong {
    color: $gray-8 !important;
    font-weight: 600;
  }
}

.wizard__line {
  display: none;

  @media (min-width: 992px) {
    background: url('./img/line.svg') no-repeat center top;
    display: block;
    height: 120px;
    left: 50%;
    position: absolute;
    transform: translateX(-42%);
    top: 294px;
    width: 604px;
    z-index: 1;
  }
}
</style>
